<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Подарки на дни рождения</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" :loading="loading" :disabled="loading" @click="sendForm" class="v-btn--save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <p>
                        Настроить автоматическое поздравление Ваших клиентов с Днем Рождения. <br/>
                        Система будет отправлять им специальное сообщение и подарок.
                    </p>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Количество бонусов</v-subheader>
                            <v-text-field
                                v-model="birthday.bonus_count"
                                ref="bonus_count"
                                v-validate="'required'"
                                data-vv-name="bonus_count"
                                :error-messages="errors.collect('bonus_count')"
                                mask="######"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">За сколько дней отправлять подарок</v-subheader>
                            <v-select
                                :items="days"
                                v-model="birthday.days_count"
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Время отправки</v-subheader>
                            <v-dialog
                                ref="dialog"
                                v-model="showTime"
                                :return-value.sync="birthday.time"
                                persistent
                                lazy
                                full-width
                                width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-on="on"
                                        v-model="birthday.time"
                                        single-line
                                        text
                                        solo
                                        readonly/>
                                </template>

                                <v-time-picker
                                    dark
                                    v-if="showTime"
                                    v-model="birthday.time"
                                    format="24hr"
                                    :allowed-minutes="allowedStep"
                                    full-width>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="showTime = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(birthday.time)">OK</v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="birthday.status ? 'Включен' : 'Отключен'" v-model="birthday.status"
                                        class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Тайтл для поздравления</v-subheader>
                            <v-text-field
                                v-model="birthday.title"
                                ref="title"
                                v-validate="'required'"
                                data-vv-name="title"
                                :error-messages="errors.collect('title')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Текст поздравления</v-subheader>
                            <v-textarea
                                ref="text"
                                v-model="birthday.text"
                                v-validate="'required|max:140'"
                                data-vv-name="text"
                                :error-messages="errors.collect('text')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                        </v-flex>
                        <v-spacer/>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0 headline">Дни рождения на ближайщую неделю</v-subheader>
                    <v-subheader class="pa-0">Сегодня</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['today']"
                                class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pa-0 mt-3">Завтра</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['tomorrow']"
                                class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pa-0 mt-3">Послезавтра</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['day_after_tomorrow']">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pa-0 mt-3">{{ lastDays(3) }}</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['2days_after_tomorrow']">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pa-0 mt-3">{{ lastDays(4) }}</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['3days_after_tomorrow']">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pa-0 mt-3">{{ lastDays(5) }}</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['4days_after_tomorrow']">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pa-0 mt-3">{{ lastDays(6) }}</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="customers['5days_after_tomorrow']">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                                <template slot="no-data">
                                    <td colspan="3" class="text-xs-center">В этот день нет дня рождений</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Customer from '../../../../api/customer'
    import GiftBirthday from '../../../../api/giftbirthday'

    export default {
        name: 'birthDayBonusLayout',
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            days: [7, 6, 5, 4, 3, 2, 1],
            showTime: false,
            allowedStep: m => m % 5 === 0,
            birthday: {
                bonus_count: null,
                days_count: 7,
                time: null,
                title: '',
                text: '',
                status: true
            },
            customers: [],
            headers: [
                {
                    text: '№',
                    value: ''
                },
                {
                    text: 'Имя',
                    value: 'name'
                },
                {
                    text: 'Номер телефона',
                    value: 'phone'
                }
            ],
            dictionary: {
                custom: {
                    title: {
                        required: 'Тайтл не введен'
                    },
                    text: {
                        required: 'Текст не введен',
                        max: 'Превышено максимальное количество символов в тексте'
                    },
                    bonus_count: {
                        required: 'Количество бонусов не указано'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
            this.getBirthdayGifts()
            this.getCustomers()
        },
        methods: {
            getBirthdayGifts () {
                GiftBirthday
                    .get()
                    .then(response => this.birthday = response.data.data)
                    .catch(error => new Error(error))
            },
            getCustomers () {
                Customer
                    .getAllBirthday()
                    .then(response => this.customers = response.data.data)
                    .catch(error => new Error(error))
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        GiftBirthday
                            .edit(this.birthday)
                            .then(() => this.$store.commit('showSnackbar', {
                                text: 'Успех! Акция успешно обновлена',
                                color: 'success'
                            }))
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            formatDate (date) {
                let dd = date.getDate()
                let mm = date.getMonth() + 1
                // let yyyy = date.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }

                return `${dd}.${mm}`
            },
            lastDays (day) {
                let d = new Date()
                d.setDate(d.getDate() + day)

                return this.formatDate(d)
            }
        }
    }
</script>
